export default "__VITE_ASSET__CJXdgsVQ__"